"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeBodyToJSON = exports.EventTypeBodyFromJSONTyped = exports.EventTypeBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function EventTypeBodyFromJSON(json) {
    return EventTypeBodyFromJSONTyped(json, false);
}
exports.EventTypeBodyFromJSON = EventTypeBodyFromJSON;
function EventTypeBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'isState': !(0, runtime_1.exists)(json, 'isState') ? undefined : json['isState'],
        'gameIds': !(0, runtime_1.exists)(json, 'gameIds') ? undefined : json['gameIds'],
        'fields': (json['fields'].map(_1.FieldConfigInputFromJSON)),
    };
}
exports.EventTypeBodyFromJSONTyped = EventTypeBodyFromJSONTyped;
function EventTypeBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'isState': value.isState,
        'gameIds': value.gameIds,
        'fields': (value.fields.map(_1.FieldConfigInputToJSON)),
    };
}
exports.EventTypeBodyToJSON = EventTypeBodyToJSON;
